import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'software',
  size: 'full',
  children: {
    applications: {
      path: 'applications',
      size: 'full',
      children: {
        account_setup: {
          level: 2,
          path: 'account_setup',
          size: 'full',
        },
        new: {
          level: 2,
          path: 'new',
          size: 'full',
        },
        applicationId: {
          level: 2,
          path: ':application_id',
          size: 'full',
          children: {
            employees: {
              path: 'employees',
              level: 3,
              size: 'full',
            },
            overview: {
              path: 'overview',
              level: 3,
              size: 'full',
            },
            spends: {
              path: 'spends',
              level: 3,
              size: 'full',
            },
            employeeId: {
              level: 3,
              path: 'employees/:employeeId',
              size: 'full',
            },
            paymentId: {
              level: 2,
              path: 'payments/:paymentId',
              size: 'full',
            },
          },
        },
        terminatedEmployees: {
          level: 2,
          path: 'terminated_employees',
          size: 'full',
          children: {
            employeeId: {
              level: 3,
              path: ':employeeId',
              size: 'full',
            },
          },
        },
      },
    },
    employees: {
      path: 'employees',
      size: 'full',
      children: {
        employeeId: {
          level: 2,
          path: ':employeeId',
          size: 'full',
        },
      },
    },
  },
} as const satisfies Location
